<script>
import formDialogCreate from '@/components/iglobalwin/formDialog';
import formPanelCreate from '@/components/iglobalwin/form-warps/dialog-form-panel/dialog-form-panel.js';
import { validRequired } from '@/common/elementValid.js';
import googleads from '@/backend/services/googleAds/googleAds.js';

function getFormData(_obj, vm) {
	let { attributes } = vm;
	let { enabled, type } = attributes;
	return {
		enabled: {
			label: '自动检测',
			formType: 'sky-switch',
			value: enabled || false,
		},
		type: {
			label: '周期',
			formType: 'sky-select',
			value: type || '',
			options: [
				{
					label: '每天',
					value: 1,
				},
				{
					label: '每周',
					value: 2,
				},
				{
					label: '每月',
					value: 3,
				},
			],
			rules: [validRequired('请选择周期', 'change')],
		},
	};
}

async function submit(data) {
	let { attributes } = this;
	let { id } = attributes;
	try {
		await googleads.setDetectionConfig({
			id,
			...data,
		});
		this.$message.success('修改成功');
		this.$emit('confirm');
	} catch (error) {
		this.$emit('cancel');
	}
}

function cancel(self) {
	self.$emit('cancel');
}

function onShowLoad(props) {
	return props || {};
}

const componentForm = formPanelCreate(
	{
		getFormData,
		submit,
		cancel,
	},
	{
		labelWidth: '110px',
	}
);

export default formDialogCreate({
	name: 'detectionConfigDialog',
	onShowLoad,
	componentForm,
});
</script>
